import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'safeString'
})
export class SafeStringPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: string | null, format: string): string {
    // Handle special case for "(nothing)" - don't pass it to DatePipe
    if (!value || value === '(nothing)') {
      return value || '';
    }
    return this.datePipe.transform(value, format) ?? '';
  }
}
